import { getTextValue } from '@/lib/helpers/LocalizedText'
import { documentTypes } from '@/config'

import camelcaseKeys from 'camelcase-keys'

import { ServiceRequests } from '@/services/service.requests'

const serviceService = new ServiceRequests()

const state = {
  configuration: null,
  tosFile: null,
}

const getters = {
  skipRegisterGuestTypeIds: (state) => { try { return state.configuration.registrationCardConfiguration.steps.find(step => step.type === 'DOCUMENT_DATA').configuration.skipRegisterGuestTypeIds } catch { return null } },
  editableFields: (state) => { try { return state.configuration.registrationCardConfiguration.steps.find(step => step.type === 'DOCUMENT_DATA').configuration.editableFields } catch { return null } },
  contactDataEnabled: (state) => { try { return state.configuration.registrationCardConfiguration.steps.find(step => step.type === 'CONTACT_DATA').enabled } catch { return false } },
  getDashboardName: (state) => ({ url }) => { try { return getTextValue(state.configuration.dashboardItems.find(dashboardItem => dashboardItem.url === url).name) } catch { return null } },
}

const actions = {
  getConfiguration ({ commit }) {
    return new Promise((resolve, reject) => {
      serviceService.getConfiguration().then((configuration) => {
        commit('setConfiguration', camelcaseKeys(configuration, { deep: true }))
        resolve(configuration)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getServiceConfiguration ({ commit }) {
    return new Promise((resolve, reject) => {
      serviceService.getServiceConfiguration().then((configuration) => {
        commit('setConfiguration', camelcaseKeys(configuration, { deep: true }))
        resolve(configuration)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getTosFile ({ commit }, { fileId }) {
    return new Promise((resolve, reject) => {
      serviceService.getPublicFile(fileId).then((file) => {
        commit('setTosFile', file)
        resolve(file)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getPublicFileImage ({ commit }, { fileId }) {
    return new Promise((resolve, reject) => {
      serviceService.getPublicFileImage(fileId).then((file) => {
        resolve(file)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

const mutations = {
  setConfiguration (state, configuration) {
    if (configuration.registrationCardConfiguration) {
      const documentDataStep = configuration.registrationCardConfiguration.steps.find(step => step.type === 'DOCUMENT_DATA')
      if (documentDataStep) {
        documentTypes.forEach(type => {
          documentDataStep.configuration[type.allowedKey] = documentDataStep.configuration[type.allowedKey]
            ? documentDataStep.configuration[type.allowedKey].map((country) => {
              return country.toLowerCase()
            }) : []
        })
      }
      var index = configuration.registrationCardConfiguration.steps.findIndex(step => step.type === 'DOCUMENT_DATA')
      if (index !== -1) {
        configuration.registrationCardConfiguration.steps[index] = documentDataStep
      }
    }
    state.configuration = configuration
  },
  setLogo (state, { logoPath, image }) {
    state.configuration.customization.logo[logoPath] = image
  },
  setTosFile (state, tosFile) {
    state.tosFile = tosFile
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
